<template>
  <div>
    {
    <br />
    <span class="pl-5">type: flex,</span>
    <br />
    <span class="pl-5">contents:</span>
    <br />
    <div class="pl-5">
      <codemirror ref="cmCode" v-model="code" :options="cmOptions" @input="onCmCodeChange"></codemirror>
    </div>

    <br />}
    <br />
  </div>
</template>

<script>
import { codemirror } from 'vue-codemirror'

// require styles
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/base16-light.css'
// require active-line.js
import 'codemirror/addon/selection/active-line.js'
// closebrackets
import 'codemirror/addon/edit/closebrackets.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/display/autorefresh.js'
export default {
  props: ['value'],
  data: function() {
    return {
      code: '',
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        showCursorWhenSelecting: true,
        matchBrackets: true,
        styleSelectedText: true,
        styleActiveLine: true,
        theme: 'base16-light',
        lineNumbers: true,
        line: true,
        autoFocus: true,
        autoRefresh: true
        // more codemirror options, 更多 codemirror 的高级配置...
      }
    }
  },
  components: {
    codemirror
  },
  mounted: function() {
    if (this.value) {
      this.code = this.value
    }
    var vm = this
    vm.$nextTick(() => {
      vm.$refs.cmCode.codemirror.refresh()
      // cm.refresh()
    })
  },
  methods: {
    onCmCodeChange: function(newCode) {
      this.code = newCode
      this.$emit('input', this.code)
    }
  },
  watch: {
    value: function(newVal) {
      this.code = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
.CodeMirror pre {
  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
}

.CodeMirror pre {
  height: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/view/intent/IntentLineFlexMessage.vue